import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fromResource, fromEntities } from 'store/selectors';
import { resourceListReadRequest, resourceUpdateRequest } from 'store/actions';

import { GuestList } from 'components';

const RESOURCE = 'passengers';

class GuestListContainer extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    loadData: PropTypes.func.isRequired,
    passengers: PropTypes.array,
  }
  componentDidMount() {
    this.props.loadData();
  }

  render() {
    return <GuestList {...this.props} />;
  }
}

const mapStateToProps = state => ({
  passengers: fromEntities.getList(state, RESOURCE, fromResource.getList(state, RESOURCE)),
});

const mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(resourceListReadRequest(RESOURCE)),
  onChange: ({ id, ...passenger }) => dispatch(resourceUpdateRequest(RESOURCE, id, passenger)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GuestListContainer);



// WEBPACK FOOTER //
// ./src/containers/GuestList.js